import React from "react";

const MyOrder = () => {
  return (
    <div>
      <div className="py-32 text-center">
        <h2 className="text-linear-gradient  font-fira font-bold text-4xl">
          Coming Soon
        </h2>
      </div>
    </div>
  );
};

export default MyOrder;
